// @ts-nocheck
import * as Types from '../../types/types';

import * as Operations from '../../queries';
import * as Apollo from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetSampleRequestConfigurationsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetSampleRequestConfigurationsQuery = {
  __typename?: 'Query';
  sampleRequestConfigurations: {
    __typename?: 'SampleRequestConfigurationConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'SampleRequestConfigurationEdge';
      node?: {
        __typename?: 'SampleRequestConfiguration';
        id: string;
        oid: string;
        name: string;
        title?: string | null;
        sampleRequestDeliveryDateEnabled?: boolean | null;
        sampleRequestAdditionalDeliveryInformationEnabled?: boolean | null;
        sampleRequestDeliveryDateMinimumDaysInFuture?: number | null;
      } | null;
    }> | null;
  };
};

/**
 * __useGetSampleRequestConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetSampleRequestConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleRequestConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleRequestConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSampleRequestConfigurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSampleRequestConfigurationsQuery,
    GetSampleRequestConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSampleRequestConfigurationsQuery,
    GetSampleRequestConfigurationsQueryVariables
  >(Operations.getSampleRequestConfigurations, options);
}
export function useGetSampleRequestConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSampleRequestConfigurationsQuery,
    GetSampleRequestConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSampleRequestConfigurationsQuery,
    GetSampleRequestConfigurationsQueryVariables
  >(Operations.getSampleRequestConfigurations, options);
}
export function useGetSampleRequestConfigurationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSampleRequestConfigurationsQuery,
        GetSampleRequestConfigurationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSampleRequestConfigurationsQuery,
    GetSampleRequestConfigurationsQueryVariables
  >(Operations.getSampleRequestConfigurations, options);
}
export type GetSampleRequestConfigurationsQueryHookResult = ReturnType<
  typeof useGetSampleRequestConfigurationsQuery
>;
export type GetSampleRequestConfigurationsLazyQueryHookResult = ReturnType<
  typeof useGetSampleRequestConfigurationsLazyQuery
>;
export type GetSampleRequestConfigurationsSuspenseQueryHookResult = ReturnType<
  typeof useGetSampleRequestConfigurationsSuspenseQuery
>;
export type GetSampleRequestConfigurationsQueryResult = Apollo.QueryResult<
  GetSampleRequestConfigurationsQuery,
  GetSampleRequestConfigurationsQueryVariables
>;
